import React from "react";

// Dibuja un sprite pixel a partir de filas de caracteres.
// Cada carácter es una clave de la paleta; "." es transparente.
const PixelArt = ({ sprite, palette, size = 64, title }) => {
  const rows = sprite.length;
  const cols = sprite[0].length;
  return (
    <svg
      viewBox={`0 0 ${cols} ${rows}`}
      width={size}
      height={size}
      shapeRendering="crispEdges"
      role="img"
      aria-label={title}
    >
      {sprite.flatMap((row, y) =>
        [...row].map((char, x) =>
          char === "." ? null : (
            <rect
              key={`${x}-${y}`}
              x={x}
              y={y}
              width="1"
              height="1"
              fill={palette[char]}
            />
          )
        )
      )}
    </svg>
  );
};

export default PixelArt;
